import { create } from 'zustand'

export type TopActionPanel = 'points' | 'tasks' | null

interface TopActionPanelState {
  openPanel: TopActionPanel
  setOpenPanel: (panel: TopActionPanel) => void
}

/**
 * Coordinates top-bar panels with actions initiated from nested workspaces.
 * This keeps task creation in place while still surfacing global progress.
 */
export const useTopActionPanelStore = create<TopActionPanelState>((set) => ({
  openPanel: null,
  setOpenPanel: (openPanel) => set({ openPanel }),
}))

export function openGlobalTaskQueue() {
  useTopActionPanelStore.getState().setOpenPanel('tasks')
}

